const STOCK_REPORT_API = {
    // STOCK REPORT
    STOCK_REPORT_LIST: "api/report/getCurrentStockReportList",
    STOCK_REPORT_BARCODE_WISE_LIST: "api/report/getBarCodeWiseCurrentStockReport",
    STOCK_REPORT_SUPPLIER_WISE_LIST: "api/report/getSupplierWiseCurrentStockReport",
    AGING_STOCK_REPORT: "api/report/getAgingStockReport",
    
};

export default STOCK_REPORT_API;